import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import PageShell from "../../../../components/layout/PageShell";
import PageHead from "../../../../components/layout/PageHead";
// import "./addnew.scss";

const Addlanguage = () => {
  const [englishContent, setEnglishContent] = useState("");
  const [frenchContent, setFrenchContent] = useState("");

  const [loading, setLoading] = useState(false);
  let token = localStorage.getItem("accessToken");
  const navitage = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const onSubmit = (data) => {
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "languages-text",
      headers: {
        "x-access-token": token,
      },
      data: {
        section: data.section,
        key: data.key,
        english: englishContent,
        french: frenchContent,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          Swal.fire({
            title: response.data.message,
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navitage("/language");
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  return (
    <PageShell><PageHead title="Add language" /><div className="new">
      <div className="newContainer">
        <Loader isLoading={loading} />
        <div className="bottom">
          <div className="modal-content">
            <div className="modal-content-title">Add Language Content</div>
            <p>&nbsp;</p>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="custome-form-group">
                <label>Page Section</label>
                <input
                  type="text"
                  name="section"
                  {...register("section", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.section && (
                  <div className="invalid-feedback">
                    {errors.section.message}
                  </div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Key</label>
                <input
                  type="text"
                  name="key"
                  {...register("key", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.key && (
                  <div className="invalid-feedback">{errors.key.message}</div>
                )}
              </div>
              <div className="custome-form-group">
                <label>English Content</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={englishContent}
                  name="englishcontent"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setEnglishContent(data);
                  }}
                />
              </div>
              <div className="custome-form-group">
                <label>French Content</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={frenchContent}
                  name="frenchcontent"
                  onChange={(e, editor) => {
                    const data = editor.getData();
                    setFrenchContent(data);
                  }}
                />
              </div>
              <button type="submit" className="approveButton">
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div></PageShell>
  );
};

export default Addlanguage;
